<!-- P/grant-finder.html:1035 — `.morebtn#moreBtn[aria-expanded][aria-controls=moreF]` over `#moreF[hidden]`. -->
<button type="button" class="agu-fold__btn" [attr.data-tone]="Tone" [attr.aria-expanded]="Open" [attr.aria-controls]="BodyId" (click)="Toggle()">
    <span>{{ Label }}</span>
    <svg class="agu-fold__chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6" /></svg>
</button>
<div class="agu-fold__body" [id]="BodyId" [hidden]="!Open">
    <ng-content />
</div>
